export enum DeferralStatusType {
  None = 0, // None- Nothing has been requested
  PendingApproval = 1, // Pending Approval - Due date has been changed and approval has been requested
  Approved = 2, // Approved  -  Date has been changed
  Rejected = 3 // Rejected - Date has not been changed
}